import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { computed, makeObservable, observable, runInAction } from "mobx";
export let AbBannerProvider = (_dec = observable.shallow, _dec2 = observable.shallow, _dec3 = observable.shallow, _dec4 = observable.shallow, _dec5 = observable.shallow, _class = class AbBannerProvider {
  constructor() {
    _initializerDefineProperty(this, "_hostedApplicationBranding", _descriptor, this);
    _initializerDefineProperty(this, "_navigationRoots", _descriptor2, this);
    _initializerDefineProperty(this, "_sideNavigationProps", _descriptor3, this);
    _initializerDefineProperty(this, "_productMenuItems", _descriptor4, this);
    _initializerDefineProperty(this, "_spaceToActionsMap", _descriptor5, this);
    _initializerDefineProperty(this, "_unsavedChangesHandlerRegistry", _descriptor6, this);
    _defineProperty(this, "_actionsVetoCallback", void 0);
    _initializerDefineProperty(this, "loginHistorySupported", _descriptor7, this);
    _initializerDefineProperty(this, "logoutSupported", _descriptor8, this);
    _initializerDefineProperty(this, "changePasswordSupported", _descriptor9, this);
    /** Control whether product name part of login dialog is displayed, and product name part of banner */
    _initializerDefineProperty(this, "productNameSupported", _descriptor10, this);
    _initializerDefineProperty(this, "getProductStatuses", _descriptor11, this);
    _initializerDefineProperty(this, "traceService", _descriptor12, this);
    /**
     * A function to call before creating the PFS, to ask the user for confirmation. The function should return
     * `true` if the PFS should be created or `false` if not.
     *
     * If undefined, PFS will be called unconditionally.
     */
    _initializerDefineProperty(this, "pfsConfirmationCallback", _descriptor13, this);
    _initializerDefineProperty(this, "pfsConfigurationCallback", _descriptor14, this);
    makeObservable(this);
    this._navigationRoots = [];
    this._sideNavigationProps = undefined;
    this._spaceToActionsMap = new Map();
    this._unsavedChangesHandlerRegistry = undefined;
    this._actionsVetoCallback = () => Promise.resolve(true);
    this.loginHistorySupported = true;
    this.logoutSupported = true;
    this.changePasswordSupported = true;
    this.productNameSupported = true;
    this.getProductStatuses = undefined;
    this.traceService = undefined;
    this.pfsConfirmationCallback = undefined;
    this.pfsConfigurationCallback = undefined;
  }
  /**
   * The root of the navigation tree configuration.
   */
  get navigationRoots() {
    return this._navigationRoots;
  }
  set navigationRoots(roots) {
    runInAction(() => {
      this._navigationRoots = roots;
    });
  }

  /**
   * The root of the side navigation configuration.
   */
  get sideNavigationProps() {
    return this._sideNavigationProps;
  }
  set sideNavigationProps(props) {
    runInAction(() => {
      this._sideNavigationProps = props;
    });
  }

  /**
   * Actions are only used by the PortalBanner
   */
  set spaceToActionsMap(spaceToActionsMap) {
    runInAction(() => {
      this._spaceToActionsMap = spaceToActionsMap;
    });
  }

  /**
   * Returns a function to return a space's actions
   * Only used by the Portal Banner
   */
  getActionsGetterForSpace(spaceIdentifyingName) {
    return this._spaceToActionsMap.get(spaceIdentifyingName);
  }

  /**
   * Calls on click before performing an action
   */
  get actionsVetoCallback() {
    return this._actionsVetoCallback;
  }
  set actionsVetoCallback(callback) {
    this._actionsVetoCallback = callback;
  }

  /**
   * The unsaved changes registry that the banner hooks into
   * This is stored here so that the main route area can tap into it when setting veto callbacks
   */
  get unsavedChangesHandlerRegistry() {
    return this._unsavedChangesHandlerRegistry;
  }
  set unsavedChangesHandlerRegistry(registry) {
    runInAction(() => {
      this._unsavedChangesHandlerRegistry = registry;
    });
  }

  /**
   * The items to be shown in the product menu at the far left of the banner.
   */
  get productMenuItems() {
    return this._productMenuItems;
  }
  set productMenuItems(productMenuItems) {
    runInAction(() => {
      this._productMenuItems = productMenuItems;
    });
  }

  /**
   * The branding of the hosted application that is currently being displayed.
   *
   * Note: this is for Portal Applications, so it isn't recommended to use it in other contexts.
   */
  get hostedApplicationBranding() {
    return this._hostedApplicationBranding;
  }
  set hostedApplicationBranding(hostedApplicationBranding) {
    runInAction(() => {
      this._hostedApplicationBranding = hostedApplicationBranding;
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_hostedApplicationBranding", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_navigationRoots", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_sideNavigationProps", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_productMenuItems", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_spaceToActionsMap", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_unsavedChangesHandlerRegistry", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "navigationRoots", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "navigationRoots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sideNavigationProps", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sideNavigationProps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productMenuItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productMenuItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hostedApplicationBranding", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hostedApplicationBranding"), _class.prototype), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "loginHistorySupported", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "logoutSupported", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "changePasswordSupported", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "productNameSupported", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "getProductStatuses", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "traceService", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "pfsConfirmationCallback", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "pfsConfigurationCallback", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
//# sourceMappingURL=AbBannerProvider.js.map
